
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Das kommt darauf an, wie viele Viren man aufnehmen muss und auch über welchen
  Weg. Das weiss man bei Covid-19 noch nicht so genau. Die Schwelle ist bei
  jedem Virus ein bisschen anders – und wahrscheinlich auch bei jeder Person.
  Die Wahrscheinlichkeit erhöht sich, wenn mehr Aerosole da sind, eine Person
  also mehr emittiert. Ob es dann zu einem Superspreading-Ereignis kommt, hängt
  auch davon ab, wie gut der Raum belüftet ist und wie ausgesetzt die Leute
  sind. Bei der ausgeatmeten Virenmenge gibt es grosse <Link href='https://www.nature.com/articles/s41598-019-38808-z' allowWordWrap mdxType="Link">Unterschiede zwischen den
  Infizierten.</Link>
    </p>
    <p>
  Aber es ist sicher nicht so, dass man nur ein- bis zweimal infizierte Luft
  einatmen muss, um sich zu infizieren und es stecken sich auch nicht immer alle
  an. Die Zeit, die man in einem Raum mit einer ansteckenden Person verbringt,
  ist entscheidend. Als groben Wert für ein erhöhtes Risiko kann man eine Dauer
  von mehreren Minuten angeben, die man in einem Raum mit infektiösen Aerosolen
  verbringt. Das BAG hält einen Kontakt mit unter 1,5 Metern Abstand und während
  mehr als 15 Minuten ohne geeigneten Schutz für kritisch. Diese Angabe kann
  aber irreführend sein, auch 5 Minuten oder 10 Minuten können unter Umständen
  für eine Ansteckung reichen.
    </p>
    <p>
  Der Arbeits- und Umwelthygieniker Michael Riediker <Link href='752619617573' allowWordWrap mdxType="Link">hat das Ansteckungsrisiko durch Aerosole
  modelliert</Link> und kommt zum Schluss, dass nur wenige Infizierte genügend Viren in
  sich tragen, um auf dem Aerosol-Weg das Virus zu übertragen. In solchen Fällen
  drohten jedoch Superspreader-Ereignisse mit vielen Ansteckungen – so wie dies
  unlängst wahrscheinlich bei einem Jodelmusical im Kanton Schwyz passiert sei.
    </p>
    <p>
  Vor kurzem hat Riediker seine Berechnungen erweitert und <Link href='https://scoeh.ch/de/tools/' allowWordWrap mdxType="Link">für das
  Staatssekretariat für Wirtschaft (Seco) ein Tool geschaffen</Link>, mit dem sich
  verschiedene Ansteckungssituationen simulieren lassen. Der Forscher bestätigt
  in der <Link href='https://scoeh.ch/en/variation-of-virus-aerosol-emissions-in-the-infected-population-and-a-tool-to-rapidly-simulate-the-airborne-virus-exposures-in-different-indoor-scenarios/' allowWordWrap mdxType="Link">dazugehörigen Veröffentlichung im Fachblatt «Aerosol and Air Quality
  Research»</Link> seine Befunde: «Etwa zehn Prozent der infizierten Bevölkerung geben
  so viel Virus ab, dass ein realistisches Ansteckungsrisiko besteht,
  insbesondere wenn sie in kleinen, schlecht belüfteten Räumen laut und lange
  sprechen.» Einer von hundert oder gar tausend Infizierten sei ein Superemitter
  und könne selbst in sehr grossen Hallen andere infizieren.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;